import * as React from 'react';
import { Layer } from 'react-map-gl';

import { ILoaderProps } from '../../layer/ILoaderProps';
import { LoadableSource } from '../../layer/LoadableSource';
import { Config } from '../../../Config';

const UrbanAreasNorth = (props: ILoaderProps) => 
  <LoadableSource path="https://apigeostore.longline.co.uk/dataset/08aa32652799a6c229fcef927d4881170eba1891" {...props}>
    <Layer
      id='urban_north'
      beforeId={Config.UI.before_layer}
      type='fill'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{ 
        "fill-color": "#d3d3d3",
        "fill-opacity": [
          'case',
          ['boolean', ['feature-state', 'hover'], false],
          0.8,
          0.5
          ]
      }}
    />
    <Layer
      beforeId={Config.UI.before_layer}
      type='line'
      layout={{ visibility: props.active ? "visible" : "none" }}          
      paint={{ 
        "line-color": "black",
        "line-width": 0.5,
      }}
    />
  </LoadableSource>

export { UrbanAreasNorth } 
